import axios from 'axios';
import * as endPoints from '../../../../Constants/Endpoints'

export function GetAppointment(appointmentId) {

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AppointmentToCancel,
    {
        params: {appointmentId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetServices() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Services,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetShopId() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ShopId,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CancelAppointmentCall(appointmentId, cancelAppointmentOption, cancelAppointmentBy, shopId) {
    console.log(appointmentId)
    const appointmentToCancel = {
        appointmentId,
        cancelAppointmentOption,
        cancelAppointmentBy
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.CancelAppointmentOpen, appointmentToCancel,
    {
        params: {shopId},
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}